var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescargarContrato(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 16 0.5 L 7 6.5 L 5 13.5 L 5 107.5 Q 5.9 114.1 10.5 117 Q 12.8 116.3 12 118.5 L 19.5 122 L 58.5 122 L 61 124.5 L 67.5 133 L 77.5 138 L 84 139.5 L 0 140 L 0 0 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 73.5 0 L 140 0 L 140 140 L 103 139.5 L 109.5 138 L 122 130.5 L 133 113.5 L 135 97.5 L 132 83.5 L 120 67 L 110.5 62 L 102 60 L 102 31.5 L 96 24 L 93 22.5 L 83.5 12 Q 81.3 12.8 82 10.5 Q 75.3 6.1 73.5 0 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 19.5 7 L 65 7 L 65 27.5 L 68 34 L 72 35 Q 70.9 37.7 73.5 37 L 74.5 38 L 95 38 L 95 58.5 Q 94.8 59.8 88.5 59 L 78.5 61 L 66.5 68 L 29.5 68 L 26 71.5 Q 25.3 75.3 27.5 76 L 29.5 77 L 59 77.5 L 54.5 84 L 28.5 84 L 26 86.5 L 27 91 L 52.5 91 L 53 94.5 Q 50.3 96.3 52 102.5 L 54 113 L 19.5 113 L 15 109.5 L 14 107.5 L 14 12.5 L 17.5 8 L 19.5 7 Z M 29 54 L 26 57 L 27 60 L 28 62 L 62 62 Q 64 61 63 56 L 62 54 L 29 54 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 73.5 14 L 82 21 L 88 29.5 L 77.5 30 Q 70.3 26.2 73.5 14 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 86.5 67 Q 101.5 65.3 109 70 Q 107.9 72.7 110.5 72 L 120 79.5 L 126 93.5 L 126 106.5 L 122 117.5 L 116.5 124 L 112 126.5 Q 112.8 128.8 110.5 128 L 106.5 131 L 99.5 133 L 87.5 133 L 75 128 L 73.5 125 L 69 122.5 L 65 117.5 L 61 106.5 L 61 93.5 L 65 82.5 L 70.5 76 L 78 72 Q 76.9 69.3 79.5 70 L 86.5 67 Z M 94 76 L 90 77 L 89 80 L 89 108 L 84 102 L 77 97 L 73 98 Q 72 104 75 107 L 82 112 L 86 119 Q 87 124 97 123 L 103 115 L 107 112 L 114 104 L 114 100 L 111 97 L 102 103 L 99 108 L 98 80 L 97 77 L 94 76 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 12.5 3 L 11.5 5 L 12.5 3 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 65.5 5 L 66.5 7 L 65.5 5 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 74.5 5 L 78.5 10 L 74.5 5 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 15.5 7 L 14.5 9 L 15.5 7 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 72.5 10 L 74.5 13 L 72 11.5 L 71.5 25 L 71 11.5 L 72.5 10 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 82.5 13 L 85.5 17 L 82.5 13 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 78.5 16 L 81.5 20 L 78.5 16 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 92.5 23 L 93.5 25 L 92.5 23 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 97.5 29 L 100.5 33 L 97.5 29 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 101.5 34 L 102 61 L 104 61.5 L 102.5 62 L 101 60.5 L 101.5 34 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 96.5 37 L 97 59.5 L 96 59.5 L 96.5 37 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 30.5 55 L 59 55.5 L 30.5 56 L 30.5 55 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 30.5 60 L 60 60.5 L 30.5 61 L 30.5 60 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 87.5 60 L 90 60.5 L 87.5 61 L 87.5 60 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 77.5 63 L 79 63.5 L 76.5 65 L 77.5 63 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 108.5 63 L 111 64.5 L 109.5 64 L 108.5 63 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 86.5 65 L 92 65.5 L 86.5 66 L 86.5 65 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 95.5 65 L 101 65.5 L 95.5 66 L 95.5 65 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 70.5 67 L 69.5 69 L 70.5 67 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 80.5 67 L 82 67.5 L 77.5 70 L 78.5 68 L 80.5 67 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 105.5 67 L 108 68.5 L 106.5 68 L 105.5 67 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 61.5 75 L 62 76.5 L 60 77.5 L 61.5 75 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 124.5 75 L 125.5 77 L 124.5 75 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 66.5 78 L 64.5 81 L 66.5 78 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 92.5 78 L 91.5 80 L 92.5 78 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 94.5 78 L 95.5 80 L 94.5 78 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 120.5 78 L 122.5 81 L 120.5 78 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 132.5 92 L 133 94.5 L 132 94.5 L 132.5 92 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 75.5 99 L 75 100.5 L 74.5 103 L 74 100.5 L 75.5 99 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 111.5 99 L 113 102.5 L 111 103.5 L 112 100.5 L 111.5 99 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 54.5 104 L 55 107.5 L 54 107.5 L 54.5 104 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 132.5 104 L 133 106.5 L 132 106.5 L 132.5 104 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 102.5 106 L 97.5 112 L 102.5 106 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 85.5 107 L 89.5 112 L 85.5 107 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 80.5 109 L 84.5 114 L 80.5 109 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 105.5 110 L 98.5 118 L 105.5 110 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 64.5 119 L 67.5 123 L 64.5 119 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 122.5 119 L 119.5 123 L 122.5 119 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 61.5 123 L 63.5 126 L 61.5 123 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 123.5 125 L 122.5 127 L 123.5 125 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 71.5 126 L 72.5 128 L 71.5 126 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 115.5 126 L 114.5 128 L 115.5 126 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 119.5 129 L 118.5 131 L 119.5 129 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 68.5 130 L 69.5 132 L 68.5 130 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 79.5 131 L 82 132.5 L 80.5 133 L 79.5 131 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 107.5 131 L 106.5 133 L 105 132.5 L 107.5 131 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 88.5 134 L 93 134.5 L 88.5 135 L 88.5 134 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 94.5 134 L 99 134.5 L 94.5 135 L 94.5 134 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.8274509803921568,
    d: "M 89.5 139 L 92 139.5 L 89.5 140 L 89.5 139 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 22.5 0 L 67.5 0 L 83 14.5 L 91.5 24 Q 93.8 23.3 93 25.5 L 101 34.5 L 101 62 Q 112.5 64.2 120 70 L 126 80 Q 128.7 78.9 128 81.5 L 131 87.5 L 133 101.5 Q 130.5 103 132 108.5 L 128 120 Q 125.3 118.9 126 121.5 L 116.5 132 L 105.5 137 L 92.5 139 L 78.5 136 Q 69.8 133.2 65 126.5 L 61 120 L 20.5 120 L 12 117 L 7 107.5 L 7 13.5 L 11 5 L 16.5 2 L 20.5 2 L 22.5 0 Z M 19 5 L 17 6 L 12 12 L 12 110 L 14 113 L 18 115 L 57 115 L 54 102 L 55 89 L 30 89 L 28 88 L 30 86 L 57 86 L 59 82 Q 58 79 61 80 L 62 75 L 31 75 L 28 73 L 31 70 L 69 70 L 74 66 L 89 61 L 97 61 L 97 36 L 76 36 L 74 35 L 67 27 L 67 5 L 19 5 Z M 72 9 L 71 26 L 72 29 L 77 32 L 92 32 L 92 30 L 84 22 Q 85 19 83 20 L 76 13 L 72 9 Z M 86 65 Q 76 67 71 73 L 64 80 L 59 93 L 59 108 L 65 122 L 78 132 L 87 135 L 101 135 L 108 133 L 119 125 L 124 119 L 128 108 L 128 93 L 123 80 L 108 67 Q 99 63 86 65 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 29.5 56 L 60.5 56 L 61 60 L 29.5 60 L 28 58.5 L 29.5 56 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 93.5 78 L 96 80.5 L 96 113 L 102 108.5 L 105 103 L 109.5 100 L 112 100 L 111 103.5 L 104.5 111 L 99 115.5 L 94.5 121 L 92.5 121 L 87 115.5 L 83.5 111 L 79 107.5 L 75 102.5 L 75 100 L 77.5 100 L 82 103 L 89.5 113 L 91 112.5 L 91 80.5 L 93.5 78 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 71.5 0 L 75 2.5 L 82 12 L 83.5 12 L 93 21.5 L 94.5 24 Q 96.8 23.3 96 25.5 L 102 32.5 L 101 32.5 L 71.5 0 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 12.5 2 L 8 7.5 L 6.5 12 L 6 8.5 L 10.5 3 L 12.5 2 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 20.5 6 L 64.5 6 L 66 7.5 L 66 26.5 L 71 34.5 L 69.5 34 Q 67.3 34.8 68 32.5 L 65 27.5 L 65 7 L 20.5 7 L 20.5 6 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 17.5 7 L 19 7.5 L 15 10.5 L 14 12.5 L 14 107.5 L 17.5 112 L 19.5 113 L 54 113 L 53 104.5 L 54 104.5 Q 53.2 110.8 56 113.5 L 54.5 115 L 22.5 115 L 16.5 113 L 14 110.5 L 12 105.5 L 12 14.5 L 17.5 7 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 72.5 11 L 81 20.5 L 73 14.5 Q 70.8 26.8 77.5 30 L 88 29.5 L 82 22.5 L 90 29.5 L 89.5 31 L 77.5 31 L 72 26.5 L 72.5 11 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 5.5 13 L 6 107.5 L 5 107.5 L 5.5 13 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 72.5 35 L 75.5 37 L 94.5 37 L 96 38.5 L 95.5 59 L 95 38 L 74.5 38 L 72 37 L 72.5 35 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 28.5 54 L 61.5 54 L 63 55.5 Q 64.3 60.8 61.5 62 L 27.5 62 L 27 60.5 L 28.5 61 L 60.5 61 L 62 59.5 Q 62.8 55.8 60.5 55 L 28.5 55 L 27 56.5 L 26.5 59 L 26 56.5 L 28.5 54 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 88.5 59 L 93 59.5 L 88.5 60 L 88.5 59 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 78.5 61 L 81 61.5 Q 71.9 63.9 66.5 70 L 28.5 70 L 27 71.5 Q 25.5 75.9 28.5 75 L 29.5 76 L 60 76 L 57 84 L 55 83.5 L 59 77.5 L 29.5 77 L 26 74.5 Q 25.3 68.8 29.5 68 L 66.5 68 L 78.5 61 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 109.5 62 L 120 67 L 132 83.5 L 134 89.5 L 134 95.5 L 133 95.5 Q 131 76.5 118.5 68 L 109.5 63 L 109.5 62 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 89.5 66 L 98 66.5 L 89.5 67 L 89.5 66 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 80.5 68 L 82 68.5 L 78 70 Q 79.1 72.7 76.5 72 L 67.5 79 L 73.5 72 L 80.5 68 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 105.5 68 L 108 69.5 L 106.5 69 L 105.5 68 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 109 70 Q 115.9 72.1 120 78.5 L 116.5 76 L 109 72 L 109 70 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 93.5 76 L 97 77 L 98 79.5 L 98.5 108 L 102 103 L 108.5 98 L 102 105.5 Q 102.8 107.8 100.5 107 L 97 109.5 L 97 80.5 L 96 78 L 93.5 77 L 91 78 L 90 80.5 L 89.5 111 L 86.5 107 Q 84.3 107.8 85 105.5 L 78.5 98 L 84 102 L 88.5 108 L 89 79.5 L 90 77 L 93.5 76 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 66.5 80 L 65 82.5 L 61 93.5 L 61 106.5 L 65 116.5 L 63 115.5 Q 59.2 108.8 59 98.5 L 61 88.5 L 66.5 80 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 120.5 80 L 125 86.5 L 128 101.5 L 125 113.5 L 122.5 117 L 122 115.5 Q 128 108.5 126 93.5 L 120.5 80 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 28.5 84 L 30 84.5 L 27 86.5 L 29 90.5 L 27 91 L 26 86.5 L 28.5 84 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 53.5 91 L 54 93.5 L 53 93.5 L 53.5 91 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 52.5 95 L 53 102.5 L 52 102.5 L 52.5 95 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 75.5 97 L 77 97.5 L 73.5 100 L 73 98 L 75.5 97 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 134.5 97 L 135 101.5 L 134 101.5 L 134.5 97 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 112.5 98 L 114 100.5 L 113 100.5 L 112.5 98 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 73.5 102 L 82 111.5 L 80.5 112 Q 74.4 108.3 73.5 102 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 113.5 102 L 114 103.5 L 106.5 112 L 104.5 113 L 113 103.5 L 113.5 102 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 133.5 103 L 134 109.5 L 131 117.5 L 120.5 132 L 108.5 138 L 108.5 137 Q 118.4 133.9 124 126.5 L 131 115.5 L 133.5 103 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 6.5 109 L 11 116.5 L 7 113.5 L 6.5 109 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 82.5 113 L 93 122.5 L 90.5 123 L 82.5 113 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 102.5 115 L 101 117.5 L 96.5 123 L 94 122.5 L 102.5 115 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 12.5 117 L 16.5 120 L 21.5 121 L 58.5 121 L 62 124.5 L 67.5 131 L 74 135.5 L 72.5 135 L 65 130.5 L 58.5 122 L 19.5 122 L 12 118.5 L 12.5 117 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 65.5 118 L 70.5 124 L 75 126.5 Q 74.3 128.8 76.5 128 L 77.5 130 L 67 121.5 L 65.5 118 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 121.5 118 L 119 121.5 L 113.5 128 L 109.5 130 L 110.5 128 Q 112.8 128.8 112 126.5 L 118 122.5 L 121.5 118 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 81.5 131 L 87 132.5 L 84.5 133 L 81.5 132 L 81.5 131 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 103.5 131 L 106 131.5 L 103.5 132 L 103.5 131 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.12156862745098039,
    d: "M 91.5 133 L 96 133.5 L 91.5 134 L 91.5 133 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 70.5 0 L 80.5 11 L 70.5 0 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 10.5 5 L 9 7.5 L 7.5 11 L 7 9.5 L 10.5 5 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 22.5 5 L 64.5 5 L 67 7.5 L 66.5 27 L 66 7.5 L 64.5 6 L 22.5 6 L 22.5 5 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 16.5 7 L 13.5 11 L 16.5 7 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 6.5 12 L 7 108.5 L 6 108.5 L 6.5 12 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 86.5 17 L 87.5 19 L 86.5 17 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 79.5 18 L 91 29.5 L 91 32 L 78 31.5 L 90 31 L 79.5 18 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 89.5 20 L 91.5 23 L 89.5 20 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 94.5 25 L 100.5 32 L 94.5 25 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 73.5 28 L 77 30.5 L 75.5 31 L 73.5 28 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 68.5 31 L 69.5 33 L 68.5 31 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 75.5 36 L 78 36.5 L 75.5 37 L 75.5 36 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 28.5 55 L 30 55.5 L 28 56 L 27.5 58 L 27 56.5 L 28.5 55 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 59.5 55 L 62 56.5 L 60.5 56 L 59.5 55 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 27.5 59 L 30 60.5 L 28.5 61 L 27.5 59 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 61.5 59 L 60.5 61 L 61.5 59 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 93.5 59 L 96 59.5 L 93.5 60 L 93.5 59 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 76.5 63 L 75.5 65 L 71.5 67 L 72.5 65 L 76.5 63 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 110.5 63 L 117 67.5 L 114.5 66 Q 110.5 65.5 110.5 63 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 92.5 65 L 95 65.5 L 92.5 66 L 92.5 65 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 85.5 66 L 89 66.5 L 85.5 67 L 85.5 66 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 98.5 66 L 102 66.5 L 98.5 67 L 98.5 66 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 68.5 68 L 67.5 70 L 68.5 68 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 118.5 68 L 125.5 76 L 118.5 68 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 72.5 72 L 67.5 78 L 72.5 72 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 114.5 72 L 119.5 78 L 114.5 72 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 29.5 75 L 60.5 75 L 61 76.5 L 59.5 76 L 29.5 76 L 29.5 75 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 126.5 77 L 127.5 79 L 126.5 77 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 66.5 79 L 64.5 82 L 66.5 79 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 120.5 79 L 122.5 82 L 120.5 79 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 90.5 80 L 91 111.5 L 90 111.5 L 90.5 80 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 96.5 80 L 97.5 110 L 101 107.5 L 96 111.5 L 96.5 80 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 30.5 84 L 57 84.5 L 30.5 85 L 30.5 84 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 27.5 88 L 29.5 90 L 53.5 90 L 55 91.5 L 53.5 91 L 29.5 91 L 27.5 88 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 53.5 94 L 54 103.5 L 53 103.5 L 53.5 94 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 59.5 94 L 60 97.5 L 59 97.5 L 59.5 94 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 127.5 94 L 128 97.5 L 127 97.5 L 127.5 94 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 133.5 96 L 134 102.5 L 133 102.5 L 133.5 96 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 75.5 98 L 77.5 98 L 85 105.5 L 77.5 99 L 74 100.5 L 73.5 102 L 73 100.5 L 75.5 98 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 109.5 98 L 113 99.5 L 111.5 99 L 109.5 99 L 102.5 106 L 109.5 98 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 59.5 102 L 60 105.5 L 59 105.5 L 59.5 102 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 127.5 102 L 128 104.5 L 127 104.5 L 127.5 102 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 74.5 103 L 79.5 109 L 74.5 103 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 112.5 103 L 106.5 110 L 112.5 103 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 86.5 107 L 88.5 110 L 86.5 107 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 132.5 107 L 133 109.5 L 132 109.5 L 132.5 107 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 14.5 111 L 15.5 113 L 14.5 111 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 82.5 112 L 91.5 122 L 82.5 112 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 103.5 113 L 95.5 122 L 103.5 113 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 9.5 114 L 11.5 117 L 9.5 114 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 19.5 114 L 22 114.5 L 19.5 115 L 19.5 114 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 63.5 116 L 67 120.5 L 64 118.5 L 63.5 116 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 123.5 116 L 123 117.5 L 119.5 122 L 122 118.5 L 123.5 116 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 21.5 120 L 58.5 120 L 61 122.5 L 58.5 121 L 21.5 121 L 21.5 120 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 126.5 122 L 124.5 125 L 126.5 122 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 68.5 123 L 70.5 126 L 68.5 123 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 118.5 123 L 116.5 126 L 118.5 123 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 62.5 125 L 67.5 131 L 62.5 125 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 123.5 126 L 121.5 129 L 123.5 126 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 117.5 131 L 115.5 134 L 113.5 135 L 114.5 133 L 117.5 131 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 70.5 132 L 71.5 134 L 70.5 132 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 102.5 132 L 105 132.5 L 102.5 133 L 102.5 132 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 86.5 133 L 91 133.5 L 86.5 134 L 86.5 133 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 96.5 133 L 101 133.5 L 96.5 134 L 96.5 133 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 73.5 134 L 78 136.5 L 76.5 137 L 73.5 134 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 86.5 139 L 89 139.5 L 86.5 140 L 86.5 139 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.5372549019607843,
    d: "M 97.5 139 L 101 139.5 L 97.5 140 L 97.5 139 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 68.5 0 L 69.5 2 L 68.5 0 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 73.5 10 L 75.5 13 L 73.5 10 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 83.5 15 L 84.5 17 L 83.5 15 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 65.5 78 L 64.5 80 L 65.5 78 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 76.5 104 L 78.5 107 L 76.5 104 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 85.5 108 L 86.5 110 L 85.5 108 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 83.5 111 L 86.5 115 L 83.5 111 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 101.5 113 L 99.5 116 L 101.5 113 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 63.5 124 L 64.5 126 L 63.5 124 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9803921568627451,
    d: "M 89.5 138 L 92 138.5 L 89.5 139 L 89.5 138 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 70.5 1 L 73.5 5 L 70.5 1 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 79.5 10 L 80.5 12 L 79.5 10 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 85.5 17 L 90.5 23 L 85.5 17 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 82.5 20 L 91.5 30 L 82.5 20 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 93.5 25 L 94.5 27 L 93.5 25 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 69.5 31 L 72.5 35 L 69.5 31 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 79.5 36 L 96 36.5 L 79.5 37 L 79.5 36 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 90.5 60 L 96 60.5 L 90.5 61 L 90.5 60 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 107.5 67 L 111 69.5 L 109.5 69 L 107.5 67 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 77.5 68 L 76.5 70 L 77.5 68 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 29.5 70 L 28.5 72 L 29.5 70 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 120.5 71 L 123.5 75 L 120.5 71 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 69.5 74 L 66.5 78 L 69.5 74 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 117.5 74 L 121.5 79 L 117.5 74 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 61.5 77 L 59.5 80 L 61.5 77 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 125.5 77 L 127.5 80 L 125.5 77 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 30.5 85 L 57 85.5 L 30.5 86 L 30.5 85 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 30.5 89 L 55 89.5 L 30.5 90 L 30.5 89 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 78.5 100 L 80.5 103 L 78.5 100 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 110.5 104 L 108.5 107 L 110.5 104 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 83.5 105 L 84.5 107 L 83.5 105 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 100.5 109 L 97.5 113 L 96 112.5 L 100.5 109 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 87.5 110 L 91 112.5 L 89.5 113 L 87.5 110 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 10.5 114 L 11.5 116 L 10.5 114 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 87.5 116 L 90.5 120 L 87.5 116 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 97.5 118 L 95.5 121 L 97.5 118 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 60.5 121 L 62.5 124 L 60.5 121 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 126.5 121 L 123.5 125 L 126.5 121 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 66.5 122 L 68.5 125 L 66.5 122 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 120.5 122 L 118.5 125 L 120.5 122 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 64.5 126 L 67.5 130 L 64.5 126 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 121.5 127 L 120.5 129 L 121.5 127 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 75.5 129 L 76.5 131 L 75.5 129 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 111.5 129 L 110.5 131 L 111.5 129 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 85.5 138 L 89 138.5 L 85.5 139 L 85.5 138 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 96.5 138 L 102 138.5 L 96.5 139 L 96.5 138 Z "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescargarContrato);
export default __webpack_public_path__ + "static/media/descargar_contrato.b354466cb6af58418be75ab5ada8f435.svg";
export { ForwardRef as ReactComponent };